export default __webpack_public_path__ + "static/media/photography.2032a557.png";